module.exports = __webpack_public_path__ + "static/media/Stellar Ora Queen Headboard - 155 cm_Light Beige.6809ca09.png";